// action-bar.types.ts
import React from 'react';

interface ActionBarProps {
	actions: React.ReactNode[];
	className?: string;
	ariaLabel: string;
}

enum ActionBarRoles {
	Toolbar = 'toolbar',
	None = 'none',
}

export { ActionBarProps, ActionBarRoles };
